export default __webpack_public_path__ + "static/media/partners-logo-zer-01-ne-w@2x.02dc5b8e.webp";